export const validatorReminder = value => {
  if (value <= 300) {
    return true
  }
  return false
}

export const validatorDatePattern = value => {
  const regex = /^\d{2}-\d{2}-\d{4}$/
  if (!regex.test(value)) {
    return false
  }
  return true
}

export const validatorIpPattern = value => {
  const ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/

  if (!ipv4Regex.test(value)) {
    return false
  }
  return true
}

export const validatorDate = value => {
  const parts = value.split('-')
  const day = Number(parts[0])
  const month = Number(parts[1])
  const year = Number(parts[2])
  const formattedDate = `${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}-${year}`
  const dateToCompare = new Date(formattedDate)

  // Create a Date object for today's date.
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  // You can compare the two dates using different comparison operators.

  // To check if dateToCompare is before today:
  if (dateToCompare.getTime() >= today.getTime()) {
    return true
  }
  return false
}

export const validatorDateComparison = value => {
  const dateToCompare = new Date(value)

  // Create a Date object for today's date.
  const today = new Date()

  // You can compare the two dates using different comparison operators.

  // To check if dateToCompare is before today:
  if (dateToCompare.getTime() >= today.getTime()) {
    return true
  }
  return false
}

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorMonthNumber = value => {
  if (value < 1) {
    return false
  }
  return true
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validateCollectionFee = value => {
  if (value <= 100) {
    return true
  }
  return false
}
